<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-12">
                                <h1 class="display-3  text-white">Smart Retail
                                </h1>
                                <p class="lead  text-white">
                                    Smart retail is data-driven, reconstructing the roles and interrelationships of people, goods, and markets. In the Internet age, fragmented consumer behavior makes traditional retail methods unsustainable. Based on data analysis and comprehensive use of data from various sources: historical transaction data, social network relationships, shopping habits, online browsing records, periodic consumption habits, etc., artificial intelligence can realize marketing forecasts and assist decision-making in retail scenarios.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        
        <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">
                        <img  src="/img/intellegence_recommendation.jpg" class="img-fluid">
                    </div>
                    <div class="col-md-6 order-md-1">
                        <div class="pr-md-5">
                            <h3 class="text-white">Intelligent recommendation</h3>
                            <p class="text-white">In new retail, artificial intelligence technology has launched personalized solutions to meet the differentiated needs of different groups of people. This personalized and customized recommendation service can improve customer experience in the retail industry. For the traditional shopping experience, shopping powered by artificial intelligence is more like an offline lifestyle, which puts forward new requirements on the retail industry ecology and also brings huge changes.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
       <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6">
                        <div class="card bg-default shadow border-0">
                            <img src="/img/smart_shelf.jpg" class="img-fluid">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="pl-md-5">
                            <h3 class="text-white">Smart shelf</h3>
                            <p class="text-white">The development direction of the new generation of retail is bound to be the intelligentization of shelf management, which effectively enhances the user experience. The placement of goods in physical stores can achieve more effective terminal management through artificial intelligence. This is of great significance to retail management, and will truly realize the entire process from decision-making to sales.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-shaped section-lg my-0">
                <div class="shape shape-style-1 bg-gradient-default">
                    <span class="span-150"></span>
                    <span class="span-50"></span>
                    <span class="span-50"></span>
                    <span class="span-75"></span>
                    <span class="span-100"></span>
                </div>
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">
                        <img  src="/img/smart_logistics.jpg" class="img-fluid">
                    </div>
                    <div class="col-md-6 order-md-1">
                        <div class="pr-md-5">
                            <h3 class="text-white">Smart logistics</h3>
                            <p class="text-white">The retail industry continues to develop. Digital product information, efficient warehousing and logistics, from product production to distribution, are forming a complete smart retail format. E-commerce giants at home and abroad have begun to deploy smart supply chains, automatically forecasting, purchasing, replenishing, and warehousing, and adjusting inventory and accurate delivery based on real-time conditions, thereby automating and precise management of massive commodity inventory</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
  name: "autonomous-driving",
  components: {
      
  }
};
</script>